/**
 * Snelkoop-lade — kies maat en kleur zonder de pagina te verlaten.
 *
 * Elk element met data-cl-qa-open="<producthandle>" opent de lade. De inhoud
 * komt van de Section Rendering API:
 *
 *     /products/<handle>?section_id=cl-qa-panel
 *
 * Dus geen nagebouwde kaart: het is dezelfde Liquid als de productpagina. De
 * kleurstalen, de prijsopmaak van de markt en de vertalingen komen daardoor
 * vanzelf goed, zonder dat deze code daar iets van hoeft te weten.
 *
 * Overgenomen uit laventaire (`laventaire-quick-add.js`). Eén ding is anders en
 * dat staat bij `voegToe()` uitgelegd: laventaire kan zijn winkelwagenlade laten
 * verversen, Stiletto niet.
 */
(function () {
  'use strict';

  var wortel = document.getElementById('cl-qa');
  if (!wortel) return;

  var cfg = {};
  try {
    cfg = JSON.parse(document.getElementById('cl-qa-config').textContent);
  } catch (e) {
    cfg = {};
  }

  // routes.root_url geeft "/de" zonder slash, en "/" op de hoofdmarkt. Zonder
  // deze normalisatie wordt de URL "/deproducts/...".
  var ROOT = (cfg.root || '/').replace(/\/*$/, '/');
  var SECTIE = 'cl-qa-panel';
  var VLAG = 'cl-pdp-look-open';

  var lade = wortel.querySelector('[data-qa-lade]');
  var body = wortel.querySelector('[data-qa-body]');
  var opener = null;        // knop waar we vandaan kwamen, voor focus-herstel
  var varianten = [];
  var gekozen = {};         // positie -> waarde
  var aantal = 1;
  var cache = {};

  function tekst(sleutel) {
    // Liquid heeft deze teksten al ge-escaped; nog een keer zou &#39; opleveren.
    // Een lege vertaling is een geldige vertaling, geen ontbrekende.
    return Object.prototype.hasOwnProperty.call(cfg.teksten || {}, sleutel)
      ? cfg.teksten[sleutel] : '';
  }

  /* ── Ophalen ───────────────────────────────────────────────────────── */
  function haal(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    return fetch(ROOT + 'products/' + encodeURIComponent(handle) + '?section_id=' + SECTIE)
      .then(function (r) {
        if (!r.ok) throw new Error('niet gevonden');
        return r.text();
      })
      .then(function (html) { cache[handle] = html; return html; });
  }

  /* ── Openen en sluiten ─────────────────────────────────────────────── */
  function open(handle, knop) {
    opener = knop || null;
    wortel.hidden = false;
    document.body.style.overflow = 'hidden';
    body.innerHTML = '<p class="cl-qa__melding">' + tekst('loading') + '</p>';
    requestAnimationFrame(function () {
      wortel.classList.add('is-open');
      // Focus in de lade zetten, anders staat de cursor nog op de knop áchter
      // het waas en tabt de bezoeker door de pagina eronder in plaats van door
      // de keuze die hij net opende.
      if (lade) { lade.setAttribute('tabindex', '-1'); lade.focus(); }
    });

    haal(handle)
      .then(function (html) {
        // De sectie komt als hele pagina terug; we willen alleen het product.
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var stuk = doc.querySelector('.cl-qa__product');
        if (!stuk) throw new Error('geen inhoud');
        body.innerHTML = '';
        body.appendChild(stuk);
        naInvoegen();
      })
      .catch(function () {
        body.innerHTML = '<p class="cl-qa__melding">' + tekst('load_error') + '</p>';
      });
  }

  function sluit() {
    wortel.classList.remove('is-open');
    document.body.style.overflow = '';
    // pas verbergen als de overgang klaar is, anders springt hij weg
    setTimeout(function () {
      if (!wortel.classList.contains('is-open')) wortel.hidden = true;
    }, 240);
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  /* ── Varianten ─────────────────────────────────────────────────────── */
  function naInvoegen() {
    var json = body.querySelector('[data-qa-varianten]');
    try {
      varianten = JSON.parse(json.textContent);
    } catch (e) {
      varianten = [];
    }

    gekozen = {};
    aantal = 1;
    // Zonder deze regel onthoudt de lade welke foto hij bij het vórige product
    // toonde, en slaat hij de sprong over als het id toevallig gelijk is.
    getoondeMedia = null;
    body.querySelectorAll('.cl-qa__waarde.is-gekozen').forEach(function (b) {
      gekozen[b.getAttribute('data-qa-positie')] = b.getAttribute('data-qa-waarde');
    });

    // Een optie met maar één waarde staat niet in de markup; die halen we uit
    // de eerste variant, anders vindt de vergelijking nooit een combinatie.
    if (varianten.length && varianten[0].opties) {
      varianten[0].opties.forEach(function (waarde, i) {
        var positie = String(i + 1);
        if (!body.querySelector('[data-qa-optie="' + positie + '"]')) {
          gekozen[positie] = waarde;
        }
      });
    }
    ververs();
  }

  function huidige() {
    for (var i = 0; i < varianten.length; i++) {
      var v = varianten[i];
      var raak = true;
      for (var k = 0; k < v.opties.length; k++) {
        if (gekozen[String(k + 1)] !== v.opties[k]) { raak = false; break; }
      }
      if (raak) return v;
    }
    return null;
  }

  function ververs() {
    var knop = body.querySelector('[data-qa-toevoegen]');
    if (!knop) return;
    var knoptekst = knop.querySelector('[data-qa-knoptekst]');
    var v = huidige();

    // Alles gekozen? Zo niet, dan vragen we daar eerst om in plaats van een
    // willekeurige variant toe te voegen — dat was precies de fout die deze
    // lade moest oplossen.
    var groepen = body.querySelectorAll('[data-qa-optie]');
    var gedaan = 0;
    groepen.forEach(function (g) {
      if (gekozen[g.getAttribute('data-qa-optie')]) gedaan++;
    });

    if (gedaan < groepen.length) {
      knop.disabled = true;
      if (knoptekst) knoptekst.textContent = tekst('select_options');
    } else if (!v || !v.beschikbaar) {
      knop.disabled = true;
      if (knoptekst) knoptekst.textContent = tekst('sold_out');
    } else {
      knop.disabled = false;
      if (knoptekst) knoptekst.textContent = tekst('add_to_cart');
      knop.setAttribute('data-qa-variant', v.id);
    }

    if (v) {
      var prijs = body.querySelector('[data-qa-prijs]');
      var was = body.querySelector('[data-qa-was]');
      if (prijs) prijs.textContent = v.prijs;
      if (was) {
        if (v.was) { was.textContent = v.was; was.hidden = false; }
        else { was.hidden = true; }
      }
      // De kortingsvlag. De tekst komt kant-en-klaar uit de variantlijst en
      // wordt hier niet samengesteld: welke bewoording deze markt krijgt (bedrag
      // of percentage) is een keuze in liquid, en die hoort niet twee keer te
      // bestaan.
      var spaar = body.querySelector('[data-qa-spaar]');
      if (spaar) {
        if (v.spaar) { spaar.textContent = v.spaar; spaar.hidden = false; }
        else { spaar.hidden = true; }
      }
      // De strook springt naar de foto van deze variant. Alleen als hij
      // verandert, anders schuift hij bij elke klik opnieuw.
      if (v.media) toonMedia(v.media);
    }

    // Kleurnaam naast het label bijwerken
    body.querySelectorAll('[data-qa-gekozen]').forEach(function (el) {
      var waarde = gekozen[el.getAttribute('data-qa-gekozen')];
      if (waarde) el.textContent = waarde;
    });

    // Combinaties die niet meer te krijgen zijn doorstrepen in plaats van
    // verbergen: dan ziet iemand dat de maat bestaat maar op is.
    body.querySelectorAll('.cl-qa__waarde').forEach(function (b) {
      var positie = b.getAttribute('data-qa-positie');
      var proef = {};
      for (var k in gekozen) proef[k] = gekozen[k];
      proef[positie] = b.getAttribute('data-qa-waarde');
      var kan = varianten.some(function (x) {
        for (var i = 0; i < x.opties.length; i++) {
          var p = String(i + 1);
          if (proef[p] && proef[p] !== x.opties[i]) return false;
        }
        return x.beschikbaar;
      });
      b.classList.toggle('is-uitverkocht', !kan);
    });
  }

  var getoondeMedia = null;
  function toonMedia(id) {
    if (String(id) === String(getoondeMedia)) return;
    var strook = body.querySelector('[data-qa-media]');
    var doel = body.querySelector('[data-qa-media-id="' + id + '"]');
    if (!strook || !doel) return;
    strook.scrollTo({ left: doel.offsetLeft - strook.offsetLeft, behavior: 'smooth' });
    getoondeMedia = id;
  }

  function zetAantal(nieuw) {
    aantal = Math.max(1, Math.min(99, nieuw));
    var el = body.querySelector('[data-qa-aantal]');
    if (el) el.textContent = aantal;
  }

  /* ── Toevoegen ─────────────────────────────────────────────────────── */
  function voegToe(knop) {
    var id = knop.getAttribute('data-qa-variant');
    if (!id) return;
    var knoptekst = knop.querySelector('[data-qa-knoptekst]');
    knop.disabled = true;
    if (knoptekst) knoptekst.textContent = tekst('adding');

    fetch(ROOT + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: aantal }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('mislukt');
        return r.json();
      })
      .then(function () {
        if (knoptekst) knoptekst.textContent = tekst('added');
        /* Hier wijkt deze lade af van die in laventaire. Daar bestaat
           `window.lvRefreshCartDrawer()` en werkt het mandje meteen bij.
           Stiletto heeft zoiets niet — gemeten: `window.theme` bevat alleen
           instellingen en `cart` staat niet op window. Twee andere routes zijn
           geprobeerd en verworpen (zie assets/cl-pdp-look.js): de hele
           lade-sectie vervangen sloopt de sluitknop, en alleen de regels
           vervangen doet niets als het mandje leeg was bij het laden.

           Wat overblijft is de pagina verversen met een vlag in sessionStorage,
           zodat de winkelwagenlade ná het laden opengaat. Dat kost een
           herlaadbeurt, maar het mandje klopt gegarandeerd — en het is precies
           wat de plusknop hiervoor ook al deed. */
        try { sessionStorage.setItem(VLAG, '1'); } catch (e) {}
        setTimeout(function () { window.location.reload(); }, 500);
      })
      .catch(function () {
        knop.disabled = false;
        if (knoptekst) knoptekst.textContent = tekst('add_error');
      });
  }

  /* ── Luisteren ─────────────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;

    var knop = e.target.closest('[data-cl-qa-open]');
    if (knop) {
      e.preventDefault();
      open(knop.getAttribute('data-cl-qa-open'), knop);
      return;
    }
    if (e.target.closest('[data-qa-sluit]')) { sluit(); return; }

    var waarde = e.target.closest('.cl-qa__waarde');
    if (waarde && wortel.contains(waarde)) {
      if (waarde.classList.contains('is-uitverkocht')) return;
      var positie = waarde.getAttribute('data-qa-positie');
      gekozen[positie] = waarde.getAttribute('data-qa-waarde');
      body.querySelectorAll('[data-qa-positie="' + positie + '"]').forEach(function (b) {
        b.classList.toggle('is-gekozen', b === waarde);
      });
      ververs();
      return;
    }

    if (e.target.closest('[data-qa-min]')) { zetAantal(aantal - 1); return; }
    if (e.target.closest('[data-qa-plus]')) { zetAantal(aantal + 1); return; }

    var toevoegen = e.target.closest('[data-qa-toevoegen]');
    if (toevoegen && wortel.contains(toevoegen) && !toevoegen.disabled) voegToe(toevoegen);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !wortel.hidden) sluit();
  });
})();
